















































































































import { Component, Vue } from 'vue-property-decorator';

// Components
import Welcome from '@/components/Global/Welcome.vue';
import TextField from '@/components/Form/TextField.vue';
import Alert from '@/components/Global/Alert.vue';
import Loading from '@/components/Global/Loading.vue';
import UmiaRoles from '@/components/Staff/UserManagement/Roles/UmiaRoles.vue';
import MmicRoles from '@/components/Staff/UserManagement/Roles/MmicRoles.vue';
import IctRoles from '@/components/Staff/UserManagement/Roles/InsureCareTeamsRoles.vue';
import RrgRoles from '@/components/Staff/UserManagement/Roles/RrgRoles.vue';
import SelectField from '@/components/Form/SelectField.vue';

// Services
import Staff from '@/services/Staff';
import * as Sentry from '@sentry/browser';
import Brand from '@/services/Brand';

@Component({
	name: 'InviteSingle',
	components: {
		Welcome,
		Alert,
		Loading,
		UmiaRoles,
		MmicRoles,
		IctRoles,
		RrgRoles,
		TextField,
		SelectField,
	},
})
export default class InviteSingle extends Vue {
	private loading: boolean;
	private error: boolean;
	private invite: any;
	private email: string;
	private success: boolean;
	private errorSave: boolean;
	private errorDelete: boolean = false;

	constructor() {
		super();

		this.loading = true;
		this.error = false;
		this.invite = {};
		this.email = '';
		this.success = false;
		this.errorSave = false;
	}

	private get siteUrl(): string {
		return Brand.getBrandUrl(this.invite.brand);
	}

	private async deleteInvite() {
		if (!confirm('Are you sure you want to delete the invite?')) {
			return;
		}

		try {
			await Staff.deleteInvites([this.invite.email]);
			this.$router.push({
				name: 'staffusermanagementinvitelist',
			});
		} catch (e) {
			console.log(e);
			this.errorDelete = true;
		}
	}

	private async saveInvitee() {
		const data = {
			cmd: 'save_invitee',
			email: this.email,
			permission: this.invite.invitee_permissions,
		};

		try {
			const updateInvite = await Staff.updateInvite(data);
			this.success = true;
			window.scrollTo(0, 0);
		} catch (e) {
			Sentry.captureException(e);
			this.errorSave = true;
			this.success = false;
			window.scrollTo(0, 0);
		}
	}

	private async created() {
		this.email = this.$route.params.email;

		try {
			const getInvites = await Staff.getInvite(encodeURIComponent(this.email));
			const data = getInvites.data;
			if ('error' in data) {
				this.error = data.error;
			} else {
				this.invite = data;
			}
		} catch (e) {
			Sentry.captureException(e);
			this.error = e;
		} finally {
			this.loading = false;
		}
	}
}
